// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__nwBoJ","disabledHover":"TableRow_disabledHover__2r7Lz"};